const Types = {
	SET_PLAN_DETAILS: 'SET_PLAN_DETAILS'
};

export default Types;
